import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import {
    DateVentilation,
    VentilationType,
    VizT,
} from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/helpers/hrVizInfos';

type Props<T extends VizT | DateVentilation | VentilationType> = {
    optionSelected: T;
    setOption: (value: T) => void;
    option1: T;
    option2: T;
};
function isVizT(param: any): param is VizT {
    return param && param.name;
}
function getOptionName(param: any): any {
    if (isVizT(param)) {
        return param.name;
    }
    return param;
}
const StyToggleButton = styled(ToggleButton, { name: 'StyToggleButton' })(
    ({ theme }) => ({
        color: theme.palette.primary.main,
        '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.lightGrey,
        },
        '&.MuiToggleButton-root': {
            '&:not(:last-child)': {
                borderTopLeftRadius: '22px',
                borderBottomLeftRadius: '22px',
            },
            '&:last-child': {
                borderTopRightRadius: '22px',
                borderBottomRightRadius: '22px',
            },
        },
        '&.MuiButtonBase-root': {
            textTransform: 'unset !important',
            fontWeight: 600,
        },
        fontSize: '11px',
    }),
);

export default function ToggleChoice<
    T extends VizT | DateVentilation | VentilationType,
>({ optionSelected, setOption, option1, option2 }: Props<T>) {
    const { t } = useTranslation();
    const handleChange = React.useCallback(
        (event: React.MouseEvent<HTMLElement>, newOption: T) => {
            if (newOption) setOption(newOption);
        },
        [setOption],
    );

    return (
        <ToggleButtonGroup
            color="primary"
            value={optionSelected}
            size="small"
            exclusive
            onChange={handleChange}
            sx={{ height: '2rem', margin: '0.2rem' }}
        >
            <StyToggleButton value={option1}>
                {isVizT(option1) && <>{option1.icon}</>}
                {t(`humanResources.${getOptionName(option1)}`)}
            </StyToggleButton>
            <StyToggleButton value={option2}>
                {isVizT(option2) && <>{option2.icon}</>}
                {t(`humanResources.${getOptionName(option2)}`)}
            </StyToggleButton>
        </ToggleButtonGroup>
    );
}
